import api from './index';
//
let exports = {};

// 获取服务基本（价格质量）要求列表-匹配用
exports.getServcBasicClaimByAppliedShop = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/list/for/met/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取配件要求列表
exports.getServcAccClaimList = function (data, callback) {
    api.post('/servc/claim/servc/acc/claim/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 获取配件要求列表
exports.getServcAccClaimInfo = function (params, callback) {
    api.get('/servc/claim/servc/acc/claim/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 新增配件要求
exports.saveServcAccClain = function (data, callback) {
    api.post('/servc/claim/servc/acc/claim/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 更新-配件要求
exports.updateServcAccClain = function (data, callback) {
    api.post('/servc/claim/servc/acc/claim/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 启禁用-配件要求
exports.updateServcAccClaimForDisabled = function (data, callback) {
    api.post('/servc/claim/servc/acc/claim/update/disabled/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除
exports.deleteServcAccClaim = function (data, callback) {
    api.post('/servc/claim/servc/acc/claim/delete/do')
    .data(data)
    .done(callback)
    .go();
};
// 获取服务类型
exports.getServcAccClaimServcType = function (params, callback) {
    api.get('/servc/claim/servc/acc/claim/servcType/get')
    .params(params)
    .done(callback)
    .go();
};
// 获取服务基本（价格质量）要求列表
exports.getServcBasicClaimList = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务基本（价格质量）要求
exports.getServcBasicClaimById = function (postData, callback) {
    api.get('/servc/claim/servc/basic/claim/get')
    .params(postData)
    .done(callback)
    .go();
};

// 获取服务基本（价格质量）要求-适用机构
exports.getServcBasicClaimAppliedShopList = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/applied/shop/get')
    .data(postData)
    .done(callback)
    .go();
};

// 保存服务基本（价格质量）要求
exports.saveServcBasicClaim = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 更新服务基本（价格质量）要求
exports.updateServcBasicClaim = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/update')
    .data(postData)
    .done(callback)
    .go();
};

// 启禁用服务基本（价格质量）要求
exports.doServcBasicClaimDisabled = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/disabled/do')
    .data(postData)
    .done(callback)
    .go();
};

// 删除服务基本（价格质量）要求
exports.deleteServcBasicClaim = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/delete')
    .data(postData)
    .done(callback)
    .go();
};

// 获取服务基本（价格质量）要求服务类型
exports.getServcBasicClaimServcType = function (postData, callback) {
    api.get('/servc/claim/servc/basic/claim/servcType/get')
    .params(postData)
    .done(callback)
    .go();
};
// （价格质量）要求同步msu
exports.doServcBasicClaimSyncMsu = function (postData, callback) {
    api.post('/servc/claim/servc/basic/claim/sync/msu/do')
    .data(postData)
    .done(callback)
    .go();
};
// 配件要求同步msu
exports.doServcAccClaimSyncMsu = function (postData, callback) {
    api.post('/servc/claim/servc/acc/claim/sync/msu/do')
    .data(postData)
    .done(callback)
    .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcClaim.js
// module id = 67
// module chunks = 1